import { render } from "./ExpenseForm.vue?vue&type=template&id=a5a17c02&bindings={}"
import script from "./ExpenseForm.vue?vue&type=script&lang=ts"
export * from "./ExpenseForm.vue?vue&type=script&lang=ts"
script.render = render

export default script